import {ApprovalStatusType} from "../enums/approval-status-type.enum";

//Fixme: How do we handle Save on status policies configured by users?
export class CurrentTxnStatus {
  currentStatus: ApprovalStatusType;
  saveEnabled = false;
  deleteEnabled = false;
  partialUpdateEnabled = false;
  submitEnabled = false;
  reSubmitEnabled = false;
  actionRequired = false;
  approved = false;
  resetEnabled= false;

  constructor(currentStatus?: ApprovalStatusType) {
    this.setStatus(currentStatus);
  }

  setStatus(currentStatus: ApprovalStatusType) {
    this.currentStatus = currentStatus;
    this.saveEnabled = CurrentTxnStatus.isEditable(currentStatus);
    this.deleteEnabled = CurrentTxnStatus.isDeletable(currentStatus);
    this.partialUpdateEnabled = CurrentTxnStatus.isPartiallyUpdatable(currentStatus);
    this.submitEnabled = CurrentTxnStatus.isSubmittable(currentStatus);
    this.reSubmitEnabled = CurrentTxnStatus.isReSubmittable(currentStatus);
    this.actionRequired = CurrentTxnStatus.hasErrors(currentStatus);
    this.approved = CurrentTxnStatus.isApproved(currentStatus);
    this.resetEnabled = CurrentTxnStatus.isApprovalResetEnabled(currentStatus);
  }

  static isEditable(currentStatus: ApprovalStatusType): boolean {
    return !currentStatus || currentStatus == ApprovalStatusType.Saved || currentStatus == ApprovalStatusType.Error || currentStatus == ApprovalStatusType.Rejected
      || currentStatus == ApprovalStatusType.ActionRequired || currentStatus == ApprovalStatusType.NotAvailable|| currentStatus == ApprovalStatusType.Cancelled;
  }

  static hasErrors(currentStatus: ApprovalStatusType): boolean {
    return !currentStatus || currentStatus == ApprovalStatusType.ActionRequired;
  }

  static isDeletable(currentStatus: ApprovalStatusType): boolean {
    return this.isEditable(currentStatus);
  }

  /**
   * @desc transaction including job-req can be partially updated using a separate method call e.g. updating hiring team
   * @param currentStatus
   */
  static isPartiallyUpdatable(currentStatus: ApprovalStatusType): boolean {
    return !(!currentStatus || currentStatus == ApprovalStatusType.Saved || currentStatus == ApprovalStatusType.Error || currentStatus == ApprovalStatusType.Rejected);
  }

  static isSubmittable(currentStatus: ApprovalStatusType): boolean {
    return this.isEditable(currentStatus);
  }

  static isReSubmittable(currentStatus: ApprovalStatusType): boolean {
    return currentStatus == ApprovalStatusType.Saved || currentStatus == ApprovalStatusType.Error || currentStatus == ApprovalStatusType.Rejected;
  }

  static isApproved(currentStatus: ApprovalStatusType): boolean {
    return currentStatus == ApprovalStatusType.Completed;
  }

  static isApprovalResetEnabled(currentStatus: ApprovalStatusType): boolean {
    return currentStatus == ApprovalStatusType.Submitted || currentStatus == ApprovalStatusType.Approved || currentStatus == ApprovalStatusType.InProgress || currentStatus == ApprovalStatusType.Assigned || currentStatus == ApprovalStatusType.Unassigned;
  }
}
